var _circle, _g, _circle2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsUnitedStatesofAmericathe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3445_26538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7841,
    cy: 21.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3445_26538)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3445_26538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7841,
    cy: 21.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3445_26538)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 38.1221,
    width: 38.1222,
    height: 43.5682,
    transform: "rotate(-90 0 38.1221)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7832,
    y: 10.8921,
    width: 5.44602,
    height: 21.7841,
    transform: "rotate(-90 21.7832 10.8921)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.7832,
    y: 21.7842,
    width: 5.44602,
    height: 21.7841,
    transform: "rotate(-90 21.7832 21.7842)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32.676,
    width: 5.44602,
    height: 43.5682,
    transform: "rotate(-90 0 32.676)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 43.5681,
    width: 5.44602,
    height: 43.5682,
    transform: "rotate(-90 0 43.5681)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 21.7842,
    width: 21.7841,
    height: 21.7841,
    transform: "rotate(-90 0 21.7842)",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1863 13.3125L16.1041 15.7604L13.5556 16.0861L15.4353 17.9248L14.9423 20.5739L17.1863 19.0611L19.4302 20.5739L18.9372 17.9248L20.8169 16.0861L18.2684 15.7604L17.1863 13.3125Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1863 -1.21021L16.1041 1.23767L13.5556 1.56337L15.4353 3.40203L14.9423 6.05116L17.1863 4.53837L19.4302 6.05116L18.9372 3.40203L20.8169 1.56337L18.2684 1.23767L17.1863 -1.21021Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3454 6.05116L11.2632 8.49903L8.71467 8.82473L10.5944 10.6634L10.1014 13.3125L12.3453 11.7997L14.5893 13.3125L14.0963 10.6634L15.976 8.82473L13.4275 8.49903L12.3454 6.05116Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89934 13.3125L5.81713 15.7604L3.26864 16.0861L5.14834 17.9248L4.6554 20.5739L6.89933 19.0611L9.14325 20.5739L8.65031 17.9248L10.53 16.0861L7.98152 15.7604L6.89934 13.3125Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89934 -1.21021L5.81713 1.23767L3.26864 1.56337L5.14834 3.40203L4.6554 6.05116L6.89933 4.53837L9.14325 6.05116L8.65031 3.40203L10.53 1.56337L7.98152 1.23767L6.89934 -1.21021Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05844 6.05116L0.976222 8.49903L-1.57227 8.82473L0.307435 10.6634L-0.185508 13.3125L2.05842 11.7997L4.30234 13.3125L3.8094 10.6634L5.6891 8.82473L3.14061 8.49903L2.05844 6.05116Z",
    fill: "#F5F7F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsUnitedStatesofAmericathe);
export default __webpack_public_path__ + "static/media/US United States of America (the).ce9fb605c1639cbee96724f6d6bd5ca0.svg";
export { ForwardRef as ReactComponent };